import { ArrowRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

import ParallaxHero from "../common/ParallaxHero/ParallaxHero";
import heroBg from "../../assets/images/hero_bg.png";
import brochure from "../../assets/docs/company-brochure.pdf";

import MotionStagger from "../common/Motion/MotionStagger";
import MotionItem from "../common/Motion/MotionItem";


function HomeHero() {
  const navigate = useNavigate();

  return (
    <ParallaxHero
    image={heroBg}
    className="relative h-[590px] lg:h-[500px] xl:h-[660px] flex flex-col overflow-visible"    overlayClassName="absolute inset-0 z-[1] bg-gradient-to-b from-[#071A2F]/30 via-[#071A2F]/40 to-[#071A2F]/50 pointer-events-none"
    imagePosition="center center"
  >

      <div className="absolute top-20 right-0 w-96 h-96 bg-red-600/10 blur-[120px] rounded-full pointer-events-none z-10" />


      {/* Diagonal Accent */}
      
      <svg
        className="
          hidden
          lg:block
          absolute
          inset-y-0
          left-1/2
          -translate-x-1/2
          w-40
          h-full
          pointer-events-none
          z-10
        "
        preserveAspectRatio="none"
        viewBox="0 0 100 300"
      >
        <line
          x1="0"
          y1="0"
          x2="100"
          y2="300"
          stroke="rgba(220,38,38,0.25)"
          strokeWidth="1.5"
        />
      </svg>
      




      <div
        className="
          relative
          z-20
          flex-1
          flex
          flex-col
          justify-center
          h-full
          max-w-7xl
          mx-auto
          px-6
          w-full
          
          pb-[calc(2.5rem+3rem)]
          sm:pb-[calc(3rem+4rem)]
        "
      >


        <MotionStagger
          className="
            w-full
            flex
            flex-col
            gap-10
            lg:flex-row
            lg:items-center
            lg:gap-16
          "
          immediate
        >


          {/* Block Operator */}

          <div className="w-full lg:w-1/2 flex flex-col justify-center gap-6">


            <MotionItem
              as="div"
              variant="fadeUp"
              className="space-y-3"
            >

              <h1
                className="
                  text-5xl
                  lg:text-6xl
                  xl:text-7xl
                  font-extrabold
                  text-white
                  leading-[0.95]
                "
              >
                Oil &amp; Gas
              </h1>


              <p
                className="
                  text-5xl
                  lg:text-6xl
                  xl:text-7xl
                  font-black
                  text-red-500
                  leading-[0.95]
                  -mt-2
                "
              >
                Block Operator
              </p>


            </MotionItem>



            <div className="space-y-5">
  <MotionItem
    as="p"
    variant="fadeUp"
    className="
      text-lg
      leading-relaxed
      text-white/90
      max-w-2xl
    "
  >
    Awarded the South Patan Oil &amp; Gas Block by the Government of
    India under the DSF 2016 programme, South Asia Consultancy is
    actively engaged in upstream energy development, bringing
    operator-level expertise to every project we undertake.
  </MotionItem>

  <MotionItem variant="fadeUp">
    <Link
  to="/major-milestone"
  className="
    group
    inline-flex
    items-center
    gap-2
    text-red-400
    font-semibold
    text-lg
    transition-all
    duration-300
    hover:text-red-300
  "
>
  Explore More

  <ArrowRight
    size={18}
    className="transition-transform duration-300 group-hover:translate-x-1"
  />
</Link>
  </MotionItem>
</div>


          </div>





          {/* Oilfield Services */}

          <div className="w-full lg:w-1/2 flex flex-col justify-center gap-6">


            <MotionItem
              as="div"
              variant="fadeUp"
              className="space-y-3"
            >

              <h2
                className="
                  text-5xl
                  lg:text-6xl
                  xl:text-7xl
                  font-extrabold
                  text-white
                  leading-[0.95]
                "
              >
                Oilfield Services
              </h2>


              <p
                className="
                  text-5xl
                  lg:text-6xl
                  xl:text-7xl
                  font-black
                  text-red-500
                  leading-[0.95]
                  -mt-2
                "
              >
                Contractor
              </p>


            </MotionItem>




           <div className="space-y-5">
  <MotionItem
    as="p"
    variant="fadeUp"
    className="
      text-lg
      leading-relaxed
      text-white/90
      max-w-2xl
    "
  >
    Delivering comprehensive offshore and onshore oilfield services
    for the upstream energy industry — from O&amp;M and drilling to
    workover and technical manpower, we provide safe, reliable, and
    efficient solutions that keep operations running smoothly.
  </MotionItem>

  <MotionItem variant="fadeUp">
    <button
      type="button"
      onClick={() => navigate("/projects")}
      className="
        group
        inline-flex
        items-center
        gap-2
        text-red-400
        font-semibold
        text-lg
        transition-all
        duration-300
        hover:text-red-300
      "
    >
      Explore More

      <ArrowRight
        size={18}
        className="transition-transform duration-300 group-hover:translate-x-1"
      />
    </button>
  </MotionItem>
</div>

          </div>


        </MotionStagger>





        {/* CTA Buttons */}

        <MotionItem
          variant="fadeUp"
          className="flex flex-wrap gap-3 sm:gap-4 mt-8"
        >


          {/* Services Button */}

          <button
            type="button"
            onClick={() => navigate("/services")}
            className="
              group
              relative
              inline-flex
              items-center
              overflow-hidden
              rounded-full
              bg-red-600
              px-6
              py-3
              text-sm
              font-semibold
              text-white
              transition-all
              duration-300
              hover:-translate-y-1
              hover:scale-[1.03]
              hover:bg-red-700
              sm:px-8
              sm:py-3.5
              sm:text-base
            "
          >

            <span className="relative z-10">
              Our Services
            </span>


            <span
              className="
                absolute
                inset-0
                -translate-x-full
                bg-gradient-to-r
                from-transparent
                via-white/20
                to-transparent
                transition-all
                duration-700
                group-hover:translate-x-full
              "
            />

          </button>





          {/* Download Brochure Button */}

          <a
             href={brochure}
            download="South-Asia-Consultancy-Company-Brochure.pdf"
            className="
              group
              relative
              inline-flex
              items-center
              overflow-hidden
              rounded-full
              border
              border-white/30
              px-6
              py-3
              text-sm
              text-white
              transition-all
              duration-300
              hover:-translate-y-1
              hover:scale-[1.03]
              hover:bg-white
              hover:text-slate-900
              hover:shadow-xl
              sm:px-8
              sm:py-3.5
              sm:text-base
            "
          >

            <span className="relative z-10">
              Download Company Brochure
            </span>


            <span
              className="
                absolute
                inset-0
                -translate-x-full
                bg-gradient-to-r
                from-transparent
                via-white/20
                to-transparent
                transition-all
                duration-700
                group-hover:translate-x-full
              "
            />

          </a>


        </MotionItem>


      </div>


    </ParallaxHero>
  );
}


export default HomeHero;